import React from "react"
import { motion } from "framer-motion"
import { cn } from "../../../lib"

const Shimmer = ({ className }) => {
  return (
    <div className={cn("relative overflow-hidden rounded-lg bg-gray-100", className)}>
      <motion.div
        className="absolute inset-0 -translate-x-full bg-gradient-to-r from-transparent via-white/60 to-transparent"
        animate={{ translateX: ["−100%", "100%"] }}
        transition={{ duration: 1.4, repeat: Infinity, ease: "linear" }}
        style={{ translateX: "-100%" }}
      >
        <motion.div
          className="absolute inset-0 bg-gradient-to-r from-transparent via-white/60 to-transparent"
          animate={{ x: ["-100%", "200%"] }}
          transition={{ duration: 1.4, repeat: Infinity, ease: "linear", repeatDelay: 0.1 }}
        />
      </motion.div>
    </div>
  )
}

export default Shimmer
